import React from 'react'
import { StyledArticleGrid } from './styled'

const ArticleGrid = ({ children }) => {
	return <StyledArticleGrid>{children}</StyledArticleGrid>
}

export default ArticleGrid
